import React, { useEffect } from 'react'
import loadable from '@loadable/component'
import kebabCase from 'lodash.kebabcase'
import { CalendlyTypes } from './types'

const InlineWidget = loadable(() =>
  import('react-calendly').then((module) => ({
    default: module.InlineWidget
  }))
)

export function CalendlyCode({ embed_url, bg_image, title }: CalendlyTypes) {
  const isCalendlyEvent = (e: Event & { data: any }) => e.data.event && e.data.event.indexOf('calendly') === 0

  const handleScheduledEvent = (e: Event & { data: any }) => {
    if (isCalendlyEvent(e)) {
      if (e.data.event === 'calendly.event_scheduled') {
        // TODO: trigger a Google Tag Manager event for the person visiting the page and schedulling an event
      }
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleScheduledEvent)

    return () => window.removeEventListener('message', handleScheduledEvent)
  }, [])

  return (
    <div
      className="bg-no-repeat bg-clip-padding bg-contain mx-auto p-24 pb-0 tablet:px-48 laptop:px-96 laptop:pt-48 w-full bg-center"
      style={bg_image?.image ? { backgroundImage: `url(${bg_image?.image})` } : undefined}
      id={kebabCase(title)}
    >
      <section>
        {title && (
          <h1 className="text-center font-bold text-headingM-mobile tablet:text-headingM mb-16 tablet:mb-0">{title}</h1>
        )}
        <div style={{ minWidth: '330px' }}>
          <InlineWidget url={embed_url} styles={{ height: '700px' }} />
        </div>
      </section>
    </div>
  )
}
